(function () {
    'use strict';

    angular.module('PWAPoCApp').controller('RouteStopMessageController', routeStopMessageController);

    routeStopMessageController.$inject = ['$scope', '$windowInstance', 'translateService', 'message'];

    function routeStopMessageController($scope, $windowInstance, translateService, message) {
        $scope.message = message.text;
        $scope.address = message.address;
        $scope.ok = ok;
        $scope.translate = translateService.translate;

        function ok() {
            $windowInstance.close();
        }
    }
})();
